import { lazy } from "react";

 const AuthLayout = lazy(() => import("./auth-layout"));
 const HelperLayout = lazy(() => import("./helper-layout"));
 const UserLayout = lazy(() => import("./UserLayout"));
 const AILayout = lazy(() => import("./AILayout"));
 const AppLayout = lazy(() => import("./AppLayout"));

export { AuthLayout, HelperLayout, UserLayout, AILayout, AppLayout };
